import React, { useState, useEffect } from "react";
import ListLayout from "../../../../../partials/content/ListLayout";
import QuotationBasicInfo from "./quotationBasicInfo";
import QuotationPrintOut from "./quotationPrintOut";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import {
  getQuotation,
  saveQuotation,
} from "../../../../../services/sales/quotationService";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import QuotationForm from "../quotationForm/quotationForm";
import ConvertToSalesOrderWizard from "../quotationForm/convertToSalesOrderWizard";
import Swal from "sweetalert2";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import Notes from "../../../common/notes";
import Attachments from "../../../common/attachments";
import DocRefInvoices from "../../../finance/invoice/docRefInvoices";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const QuotationDetail = ({ match, history }) => {
  const { reload } = useGlobalData();
  const quotationID = match.params.quotationID;
  const [quotation, setQuotation] = useState({
    salesOrderID: 0,
    approvalProcessID: 0,
    approvalProcess: {
      statusID: 0,
    },
  });
  const [approvalProcess, setApprovalProcess] = useState([]);
  const [approvalSteps, setApprovalSteps] = useState([]);
  const [approvalActiveStep, setApprovalActiveStep] = useState(0);
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [openConfirmSoDialog, setOpenConfirmSoDialog] = useState(false);
  const [auth, setAuth] = useState({});
  const [openQuotationForm, setOpenQuotationForm] = useState(false);
  const [listMenu, setListMenu] = useState([
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "dpInvoice",
      label: "DP Invoice",
      icon: "fas fa-file-invoice-dollar",
    },
    {
      key: "attachments",
      label: "Attachments",
      icon: "fas fa-paperclip",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
    {
      key: "printOut",
      label: "PrintOut",
      icon: "fas fa-print",
    },
  ]);

  const defaultSelected = "basicInfo";

  useEffect(() => {
    getQuotationData(quotationID);
  }, [quotationID, reload]);
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/sales/quotation/quotation-list");
      },
    },
  ];
  if (
    quotation.edit &&
    (quotation.approvalProcessID === 0 ||
      quotation.approvalProcess.statusID === 2 ||
      quotation.approvalProcess.statusID === 3) &&
    quotation.salesStatus !== 3 &&
    quotation.salesStatus !== 4
  ) {
    actionButtons.push({
      title: "Edit Quotation",
      color: "primary",
      icon: "fas fa-edit",
      onClick: () => {
        history.push(`/sales/quotation/edit-quotation/${quotationID}`);
      },
    });
  }
  if (
    (quotation.approvalProcessID === 0 ||
      quotation.approvalProcess.statusID === 2 ||
      quotation.approvalProcess.statusID === 3) &&
    quotation.salesStatus !== 3 &&
    quotation.salesStatus !== 4
  ) {
    actionButtons.push({
      title: "Sales Lost",
      color: "danger",
      icon: "fas fa-heart-broken",
      onClick: () => {
        const quotationUpdate = { ...quotation };
        quotationUpdate.salesStatus = 4;
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to mark this Quotation as Lost ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, mark it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveQuotation(quotationUpdate).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Marked as Lost",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                history.push("/sales/quotation/quotation-list");
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      },
    });
    actionButtons.push({
      title: "Sales Won",
      color: "success",
      icon: "fas fa-trophy",
      onClick: () => {
        setOpenConfirmSoDialog(true);
      },
    });
  }

  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/quotation/quotation-list",
            title: "Quotations",
            active: false,
          },
          {
            page: "/sales/quotation/quotation-detail/" + quotationID,
            title: "Quotation ID " + quotation.quotationCode,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            let selectedComponent;
            switch (key) {
              case "basicInfo":
                selectedComponent = (
                  <QuotationBasicInfo
                    quotationImp={quotation}
                    approvalProcessImp={approvalProcess}
                    approvalStepsImp={approvalSteps}
                    approvalActiveStepImp={approvalActiveStep}
                  />
                );
                setHeaderTitle("Basic Info");
                break;
              case "dpInvoice":
                selectedComponent = (
                  <DocRefInvoices
                    docRef="5"
                    docID={quotation.ID}
                    history={history}
                  />
                );
                setHeaderTitle("DP Invoice");
                break;
              case "attachments":
                selectedComponent = (
                  <Attachments docType="QUOT" docID={quotation.ID} />
                );
                setHeaderTitle("Attachments");
                break;
              case "notes":
                selectedComponent = (
                  <Notes docType="QUOT" docID={quotation.ID} />
                );
                setHeaderTitle("Notes");
                break;
              case "printOut":
                selectedComponent = <QuotationPrintOut quotation={quotation} />;
                setHeaderTitle("Print Out");
                break;
              default:
                selectedComponent = (
                  <QuotationBasicInfo
                    quotationImp={quotation}
                    approvalProcessImp={approvalProcess}
                    approvalStepsImp={approvalSteps}
                    approvalActiveStepImp={approvalActiveStep}
                  />
                );
                setHeaderTitle("Basic Info");
                break;
            }
            setComponent(selectedComponent);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
      <DialogLayout
        open={openConfirmSoDialog}
        title="Convert Quotation to Sales Order"
        onCloseDialog={() => {
          setOpenConfirmSoDialog(false);
        }}
        maxWIdth="lg"
        minHeight={true}
      >
        <ConvertToSalesOrderWizard
          history={history}
          quotationID={quotation.ID}
          onCloseDialog={() => {
            setOpenConfirmSoDialog(false);
          }}
          onConfirmSave={() => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Marked as Won",
              text: "Quotation has been converted to Sales Order",
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            history.push("/sales/sales-order/sales-order-list");
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openQuotationForm}
        title=""
        maxWIdth="xl"
        onCloseDialog={handleCloseQuotationForm}
      >
        <QuotationForm
          quotationIDImp={quotation.ID}
          onCloseDialog={handleCloseQuotationForm}
          headSubmitButton={false}
          onConfirmSave={() => {
            getQuotationData(quotationID);
            handleCloseQuotationForm();
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleCloseQuotationForm() {
    setOpenQuotationForm(false);
  }

  async function getQuotationData(quotationID) {
    const response = await getQuotation(quotationID);
    const { data, auth } = response.data;
    const componentTmp = (
      <QuotationBasicInfo
        quotationImp={data.quotation}
        approvalProcessImp={data.approvalProcess}
        approvalStepsImp={data.quotation.approvalProcess.approval.approvalValue}
        approvalActiveStepImp={data.quotation.approvalProcess.level}
      />
    );
    setAuth(auth);
    setQuotation(data.quotation);
    setApprovalProcess(data.approvalProcess);
    setApprovalSteps(data.quotation.approvalProcess.approval.approvalValue);
    setApprovalActiveStep(data.quotation.approvalProcess.level);
    setComponent(componentTmp);
  }
};

export default QuotationDetail;
